import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { MedNecCaseSliceState } from './state';
import { medNecApi } from '../medNecApi';

export function buildMedNecExtraReducers(builder: ActionReducerMapBuilder<MedNecCaseSliceState>) {
  builder
    .addMatcher(
      medNecApi.endpoints.getCaseById.matchFulfilled,
      (state, action) => {
        state.currentCase = action.payload;
        state.serverCase = JSON.parse(JSON.stringify(action.payload));
        state.selectedCaseId = action.payload.id;
        state.isEdited = false;
        state.editedFields = [];
      }
    )
    .addMatcher(
      medNecApi.endpoints.updateCase.matchFulfilled,
      (state) => {
        if (state.currentCase) {
          state.serverCase = JSON.parse(JSON.stringify(state.currentCase));
        }
        state.isEdited = false;
        state.editedFields = [];
      }
    )
    .addMatcher(
      medNecApi.endpoints.createCase.matchFulfilled,
      (state, action) => {
        state.currentCase = action.payload;
        state.selectedCaseId = action.payload.id;
        state.draftCase = null;
      }
    );
}
